import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3;

import { css } from "../../../lib/theming/Emotion";
import { getMenuItemPaddings } from "../MenuItem.styles";
export var menuItemSizeMixin = function menuItemSizeMixin(menuItemLegacyPaddingX, menuItemPaddingX, menuItemLegacyPaddingY, menuItemPaddingY, menuItemLineHeight, menuItemFontSize) {
  var _getMenuItemPaddings = getMenuItemPaddings({
    menuItemLegacyPaddingX: menuItemLegacyPaddingX,
    menuItemPaddingX: menuItemPaddingX,
    menuItemLegacyPaddingY: menuItemLegacyPaddingY,
    menuItemPaddingY: menuItemPaddingY
  }),
      paddingX = _getMenuItemPaddings.paddingX,
      paddingY = _getMenuItemPaddings.paddingY;

  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    line-height: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", " ", ";\n  "])), menuItemLineHeight, menuItemFontSize, menuItemPaddingY, paddingX, paddingY, menuItemPaddingX);
};
export var iconSizeMixin = function iconSizeMixin(menuItemIconWidth, menuItemPaddingX, menuItemIconLegacyMargin) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    width: ", ";\n    left: ", "px;\n  "])), menuItemIconWidth, parseInt(menuItemPaddingX) + parseInt(menuItemIconLegacyMargin));
};
export var withIconSizeMixin = function withIconSizeMixin(menuItemPaddingForIcon) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n  "])), menuItemPaddingForIcon);
};